import { Box } from '@mui/material';

export function Copyright() {
  return (
    <Box
      component="footer"
      sx={{
        p: 2,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 500,
        color: 'text.secondary',
        flexShrink: 0,
      }}
    >
      ©{new Date().getFullYear()} Deview
    </Box>
  );
}
